import React from 'react';
import { FaRobot, FaLock, FaBrain, FaChartLine, FaRocket, FaCode } from 'react-icons/fa';
import { FeatureItemProps, FeaturesContent } from '../types';

export const featuresContent: FeaturesContent = {
  heading: 'Key Features',
  description: 'Our agentic systems combine cutting-edge AI capabilities with enterprise-grade reliability'
};

export const features: FeatureItemProps[] = [
  {
    title: 'Autonomous Operation',
    text: 'Our agentic systems operate independently, making decisions and taking actions without continuous human supervision.',
    icon: React.createElement(FaRobot),
  },
  {
    title: 'Enterprise Security',
    text: 'Built with security-first architecture, our systems protect sensitive data and comply with industry regulations.',
    icon: React.createElement(FaLock),
  },
  {
    title: 'Cognitive Intelligence',
    text: 'Advanced reasoning capabilities allow our agents to understand context, learn from experience, and adapt to new situations.',
    icon: React.createElement(FaBrain),
  },
  {
    title: 'Performance Analytics',
    text: 'Comprehensive dashboards and insights help you monitor, measure, and optimize your agentic systems.',
    icon: React.createElement(FaChartLine),
  },
  {
    title: 'Scalable Architecture',
    text: 'Our systems scale effortlessly from handling simple tasks to managing complex enterprise operations.',
    icon: React.createElement(FaRocket),
  },
  {
    title: 'Seamless Integration',
    text: 'Integrate with your existing tools and systems through our extensive API and connector library.',
    icon: React.createElement(FaCode),
  },
];